import React from 'react';
import { Col } from 'react-bootstrap';

export const TeamMember = ({ name, job, image, socialLinks }) => {
	const links = socialLinks.map(link => (
		<li key={link.platform} className={link.platform}>
			<a href={link.link}>
				<span className={`fa fa-${link.platform}`} />
			</a>
		</li>
	));

	return (
		<Col className="team-member" md={4} sm={6} xs={12}>
			<div className="inner-box">
				<div className="image">
					<img src={require('../../../assets/images/team')[image]} alt={name} />
				</div>
				<div className="lower-content">
					<h3>{name}</h3>
					<div className="designation">{job}</div>
					<ul className="social-icon-two">
						{links}
					</ul>
				</div>
			</div>
		</Col>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Team/TeamMember.js